import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { useState } from "react";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";

export interface CreditApplicationStyles {
    subscriptionItem?: InjectableCss;
    creditApplicationFormTitle?: TypographyProps;
    formWrapper?: InjectableCss;
    MultiCreditFormWrapper?: InjectableCss;
}

export const creditApplicationStyles: CreditApplicationStyles = {
    MultiCreditFormWrapper: {
        css: css`
            margin-bottom: 20px;
        `,
    },
    formWrapper: {
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
            h4 {
                font-weight: 600;
            }
            .fullWidthForMobileDevices {
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 100% !important;
                                `,
                            ],
                            "max",
                        )}
                }
            }
            > div[class^="GridWrapper"] {
                margin-top: 10px;
                padding-left: 0;
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin: 0;
                }
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    border: 1px solid red;
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    creditApplicationFormTitle: {
        variant: "h4",
        css: css`
            margin-block: 5px 20px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-block: 5px;
                        text-align: center;
                        font-size: 16px;
                    `,
                    css`
                        margin-block: 5px;
                        text-align: center;
                        font-size: 16px;
                    `,
                    css`
                        margin-block: 5px;
                        text-align: center;
                        font-size: 16px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    subscriptionItem: {
        css: css`
            font-size: 16px;
        `,
    },
};

const styles = creditApplicationStyles;

const CreditApplicationToggle = ({ id }: WidgetProps) => {
    const [isCheckedMultifamilyCredit, setCheckedMultifamilyCredit] = useState(false);
    const [isCheckedCredit, setCheckedCredit] = useState(false);

    const handleChangeMultiFamilyCredit = () => {
        setCheckedMultifamilyCredit(!isCheckedMultifamilyCredit);
        setCheckedCredit(false); // Uncheck the other checkbox
    };

    const handleChangeCredit = () => {
        setCheckedCredit(!isCheckedCredit);
        setCheckedMultifamilyCredit(false); // Uncheck the other checkbox
    };

    return (
        <StyledWrapper {...styles.formWrapper}>
            <GridContainer>
                <StyledWrapper {...styles.MultiCreditFormWrapper}>
                    <Typography {...styles.creditApplicationFormTitle}>
                        {translate("Please Select one of the terms account form below")}
                    </Typography>
                    <CheckboxGroup {...styles.subscriptionItem}>
                        <Checkbox checked={isCheckedCredit} onChange={handleChangeCredit}>
                            {translate("Credit Form")}
                        </Checkbox>
                    </CheckboxGroup>
                    <CheckboxGroup>
                        <Checkbox onChange={handleChangeMultiFamilyCredit} checked={isCheckedMultifamilyCredit}>
                            {translate("Multifamily Credit Form")}
                        </Checkbox>
                    </CheckboxGroup>
                </StyledWrapper>
                <StyledWrapper>
                    {isCheckedCredit && (
                        <StyledWrapper>
                            <Zone contentId={id} zoneName="CreditApplication" />
                        </StyledWrapper>
                    )}
                    {isCheckedMultifamilyCredit && (
                        <StyledWrapper>
                            <Zone contentId={id} zoneName="MultiFamilyCreditApplication" />
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            </GridContainer>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: connect(null, null)(CreditApplicationToggle),
    definition: {
        displayName: "Credit Application Toggle",
        group: "Basic",
        icon: "FormField",
        fieldDefinitions: [],
    },
};
export default widgetModule;
